import axios, { type AxiosInstance } from 'axios'

const ACCOUNT_ID_RAW = import.meta.env.VITE_CHATWOOT_ACCOUNT_ID ?? '1'
const API_BASE = import.meta.env.VITE_CHATWOOT_API_BASE ?? '/api'

export const ACCOUNT_ID = Number(ACCOUNT_ID_RAW)

// Cliente "scoped" para tudo dentro de /api/v1/accounts/{id}
export const chatwoot: AxiosInstance = axios.create({
  baseURL: `${API_BASE}/v1/accounts/${ACCOUNT_ID}`,
  headers: { 'Content-Type': 'application/json' },
})

// Cliente para endpoints fora da scope de account (ex.: /auth/sign_in)
export const chatwootAuth: AxiosInstance = axios.create({
  baseURL: '/auth',
  headers: { 'Content-Type': 'application/json' },
})

let currentToken: string | null = null

export function setToken(token: string | null): void {
  currentToken = token
}

chatwoot.interceptors.request.use((config) => {
  if (currentToken) {
    config.headers.set('api_access_token', currentToken)
  }
  return config
})

// Evento global emitido em 401 — o auth store escuta e faz logout/redirect.
// Desacopla axios do Pinia (evita ciclo de imports).
chatwoot.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      window.dispatchEvent(new CustomEvent('chatwoot:unauthorized'))
    }
    return Promise.reject(error)
  },
)
